import React, { useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core";

const fabric = require("fabric").fabric;

const useStyles = makeStyles((theme) => ({
  container: { width: 300, height: 300, overflow: 'hidden' },
}));

const SketchView = (props) => {
  const { data } = props;
  const { sketch = null } = data;
  const classes = useStyles();

  const canvasRef = useRef(null);
  const fcRef = useRef(null);
  const containerRef = useRef(null);

  const fromJSON = (json) => {
    if (!json) return;
    let canvas = fcRef.current;
    if (!canvas) return;
    setTimeout(() => {
      canvas.loadFromJSON(json, () => {
        canvas.renderAll();
        resize();
      });
    }, 300);
  };

  const resize = () => {
    let canvas = fcRef.current;
    canvas.setWidth(300);
    canvas.setHeight(300);
    const factor = 0.77;
    let objects = canvas.getObjects();
    for (let i in objects) {
      objects[i].scaleX = objects[i].scaleX * factor;
      objects[i].scaleY = objects[i].scaleY * factor;
      objects[i].left = objects[i].left * factor;
      objects[i].top = objects[i].top * factor;
      objects[i].setCoords();
    }
    canvas.renderAll();
    canvas.calcOffset();
  };

  useEffect(() => {
    fcRef.current = new fabric.Canvas(canvasRef.current);
  }, []);

  useEffect(() => {
    if (sketch) fromJSON(sketch);
  }, [sketch]);

  // useEffect(() => {
  //   if (fcRef.current && canvasRef.current) {
  //   }
  // }, [fcRef, canvasRef]);

  return (
    <div className={classes.container} ref={containerRef}>
      <canvas id={"sketch-view"} ref={canvasRef}>
        Sorry, Canvas HTML5 element is not supported by your browser :(
      </canvas>
    </div>
  );
};

export default SketchView;
